<template>
    <div class="container pt-4">
        <div class="columns is-centered is-multiline">
            <div class="column is-12">
                <div class="box">
                    <WeekRooms />
                </div>
            </div>
            <div class="column is-4">
                <div class="box">
                    <ConnectedUsers />
                </div>
            </div>
            <div class="column is-4">
                <div class="box">
                    <LastClosedRooms />
                </div>
            </div>
            <div class="column is-4">
                <div class="box">
                    <ActiveRooms />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WeekRooms from "./weekRooms/WeekRooms"
import ConnectedUsers from "./connectedUsers/ConnectedUsers";
import LastClosedRooms from "./closedRooms/LastClosedRooms";
import ActiveRooms from "./activeRooms/ActiveRooms";

export default {
    name: "dashboard",
    components: {
        WeekRooms,
        ConnectedUsers,
        LastClosedRooms,
        ActiveRooms,
    },
};
</script>